import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
  useMediaQuery,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";
import { footerContents } from "src/resources/data/landingPageData";
import { useNavigate } from "react-router-dom";

const FooterSection: React.FC = () => {
  const navigate = useNavigate();
  const isBelow770 = useMediaQuery('(max-width:770px)');

  return (
    <Box component="footer" sx={{ px: 4, py: 6, fontFamily: "sans-serif", width: "100%", backgroundColor: "#f9f9f9" }}>
      <Box
        display={isBelow770 ? "block" : "flex"}
        justifyContent="space-between"
        flexWrap="wrap"
        gap={4}
      >
        {footerContents.map(({ title, content, icons }, idx) => {
          const isAccordion = isBelow770;

          return (
            <Box key={title || idx} flex={1} minWidth={isAccordion ? "100%" : "200px"}>
              {isAccordion ? (
                <Accordion sx={{ backgroundColor: "transparent", boxShadow: "none", borderBottom: "1px solid #eee" }}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography fontWeight="bold" fontSize="1.2rem">
                      {title}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {content ? (
                      <Box display="flex" flexDirection="column" gap={1}>
                        {content.map((item: any, i: number) => (
                          <Typography
                            key={i}
                            variant="body2"
                            sx={{ color: "#999", cursor: "pointer", "&:hover": { color: "black", textDecoration: "underline" } }}
                            onClick={() => item.link && navigate(item.link)}
                          >
                            {item.title}
                          </Typography>
                        ))}
                      </Box>
                    ) : icons ? (
                      <Box display="flex" gap={2} fontSize="1.5rem" color="#999">
                        {icons.map((iconObj: any, i: number) =>
                          React.createElement(iconObj.icon, {
                            key: i,
                            onClick: () => {
                              if (iconObj.link) {
                                window.open(iconObj.link, '_blank', 'noopener,noreferrer');
                              }
                            },
                            style: { cursor: iconObj.link ? "pointer" : "default" }
                          })
                        )}
                      </Box>
                    ) : <></>
                    /**  (
                       <Box>
                         <Typography color="textSecondary" fontSize="0.95rem" mb={2}>
                           {subTitle}
                         </Typography>
                         <Box display="flex" gap={1}>
                           <TextField
                             variant="outlined"
                             placeholder={inputName}
                             size="small"
                             fullWidth
                           />
                           <Button
                             variant="contained"
                             sx={{
                               backgroundColor: "#e65f78",
                               "&:hover": { backgroundColor: "#d14c66" },
                               whiteSpace: "nowrap",
                             }}
                           >
                             {buttonName}
                           </Button>
                         </Box>
                       </Box>
                     ) */
                    }
                  </AccordionDetails>
                </Accordion>
              ) : (
                <Box>
                  <Typography fontWeight="bold" fontSize="1.2rem" mb={2}>
                    {title}
                  </Typography>
                  {content ? (
                    <Box display="flex" flexDirection="column" gap={1}>
                      {content.map((item: any, i: number) => (
                        <Typography
                          key={i}
                          variant="body2"
                          sx={{ color: "#999", cursor: "pointer", "&:hover": { color: "black", textDecoration: "underline" } }}
                          //TODO: Fix this navigation logic
                          onClick={() => item.link && navigate('/') && navigate(item.link) && window.scrollTo({ top: 0, behavior: 'smooth' })}
                        >
                          {item.title}
                        </Typography>
                      ))}
                    </Box>
                  ) : icons ? (
                    <Box display="flex" gap={2} fontSize="1.5rem" color="#999">
                      {icons.map((iconObj: any, i: number) =>
                          React.createElement(iconObj.icon, {
                            key: i,
                            onClick: () => {
                              if (iconObj.link) {
                                window.open(iconObj.link, '_blank', 'noopener,noreferrer');
                              }
                            },
                            style: { cursor: iconObj.link ? "pointer" : "default" }
                          })
                        )}
                    </Box>
                  ) : <></>
                  /**  (
                     <Box maxWidth="300px">
                       <Typography color="textSecondary" fontSize="0.95rem" mb={2}>
                         {subTitle}
                       </Typography>
                       <Box display="flex" gap={1}>
                         <TextField
                           variant="outlined"
                           placeholder={inputName}
                           size="small"
                           fullWidth
                         />
                         <Button
                           variant="contained"
                           sx={{
                             backgroundColor: "#e65f78",
                             "&:hover": { backgroundColor: "#d14c66" },
                             whiteSpace: "nowrap",
                           }}
                         >
                           {buttonName}
                         </Button>
                       </Box>
                     </Box>
                   ) */
                  }
                </Box>
              )}
            </Box>
          );
        })}
      </Box>

      <Typography
        textAlign="center"
        mt={6}
        color="#888"
        fontSize="0.9rem"
      >
        Copyright ©2025 All rights reserved
      </Typography>
    </Box>
  );
};

export default FooterSection;
